module.exports = __webpack_public_path__ + "static/media/social-dribble.7c554482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-dribble.svg
// module id = 73
// module chunks = 0